import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import React from "react";
import axios from "axios";
import { LinkValues, LocalValues } from "../values/strings";
import getUserLocale from "get-user-locale";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    backend: {
      loadPath: "/assets/locale/{{lng}}.json",
    },
    fallbackLng: "en",
    detection: {
      order: ["path", "cookie", "localStorage", "htmlTag"],
      caches: ["cookie"],
      lookupFromPathIndex: 0,
      checkWhitelist: true,
    },
    debug: false,
    react: {
      useSuspense: false,
    },
  });

const LanguageContext = React.createContext();

export const LanguageProvider = ({ children }) => {
  const SupportedLanguages = ["FA", "EN"];

  const { t, i18n } = useTranslation();
  document.body.dir = i18n.dir();

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    document.body.dir = i18n.dir ? i18n.dir() : "ltr";
  };

  const getAcceptLanguage = () => {
    const lang = (i18n.language && i18n.language.toLowerCase()) || "";
    if (lang === "fa") {
      return "fa-ir,fa";
    }
    return "en-us,en";
  };

  React.useEffect(() => {
    axios.get(LinkValues.externals.apis.geoLocationDB.json()).then((res) => {
      if (LinkValues.routes.isRouteUseLocale(SupportedLanguages)) return;
      if (
        res &&
        res.data &&
        "country_code" in res.data &&
        res.data.country_code in LocalValues
      ) {
        LinkValues.routes.setLocale(
          LocalValues[res.data.country_code],
          SupportedLanguages
        );
      } else {
        LinkValues.routes.setLocale(LocalValues.self, SupportedLanguages);
      }
    });
  }, [t]);

  const textDirectionDetector = () => {
    return i18n.dir ? i18n.dir() : "ltr";
  };

  return (
    <LanguageContext.Provider
      value={{
        supportedLanguages: SupportedLanguages,
        changeLanguage,
        getAcceptLanguage,
        textDirection: textDirectionDetector,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageProvider = () => {
  return React.useContext(LanguageContext);
};
